var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import padding from "@irati/ui/src/global/padding";
import ErrorText from "@irati/ui/src/ErrorText";
import Error from "@irati/ui/src/Loading/Error";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
var MobileValidationButton = styled(ValidationButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.tiny);
var StyledError = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.tiny);
var CTA = /** @class */ (function (_super) {
    __extends(CTA, _super);
    function CTA(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            apolloState: props.apolloState
        };
        return _this;
    }
    /* The getDerivedStateFromProps below is a temporary hack that only returns unmodified apolloState if the previous
    apolloState was loading. Otherwise it overrides apolloState.error to null. This means any time the user updates a
    form field the error will be hidden. It should be the responsibility of react-apollo to reset error to null on
    rerender/ when props are changed and is a common issue that other people are experiencing ie:
      https://github.com/apollographql/react-apollo/issues/2191
    We shall keep our eye on react-apollo and when it's fixed on there end, we can update our package and remove the
    function below. */
    CTA.getDerivedStateFromProps = function (props, prevState) {
        var apolloState = props.apolloState;
        if (prevState.apolloState.loading) {
            return { apolloState: apolloState };
        }
        return { apolloState: __assign(__assign({}, apolloState), { error: null }) };
    };
    CTA.prototype.render = function () {
        var _a = this.props, onNext = _a.onNext, nextText = _a.nextText, id = _a.id, trophyValidationError = _a.trophyValidationError, formatMessage = _a.formatMessage;
        var apolloState = this.state.apolloState;
        var INVALID_ARGS_ERROR_CODE = "PBRECInvalidArguments";
        return (React.createElement(Row, null,
            apolloState.error && (React.createElement(Col, { xs: 12 },
                React.createElement(StyledError, null, apolloState.errorMsg.includes(INVALID_ARGS_ERROR_CODE) && trophyValidationError ? (React.createElement(ErrorText, null, formatMessage({ id: "recognition.popup.shared.cta.noTrophySelected.message" }))) : (React.createElement(Error, { errorMsg: apolloState.errorMsg }))))),
            React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                React.createElement(MobileValidationButton, { id: id, apolloState: apolloState, onClick: onNext, primary: true, large: true, full: true }, nextText || React.createElement(FormattedMessage, { id: "recognition.popup.shared.cta.launch" }))),
            React.createElement(Col, { xsHidden: true, sm: 12 },
                React.createElement(ValidationButton, { id: id, onClick: onNext, apolloState: apolloState, primary: true, large: true, full: true }, nextText || React.createElement(FormattedMessage, { id: "recognition.popup.shared.cta.launch" })))));
    };
    CTA.defaultProps = {
        nextText: null,
        id: null
    };
    return CTA;
}(Component));
export default injectIntl(CTA);
var templateObject_1, templateObject_2;
